// Logo constants - shared between recipe labels (jQuery UI) and supplement labels (Vue)
// Separated from logo.js to avoid jQuery dependency when only constants are needed

const MIN_SCALE = 0.25;
const MAX_SCALE = 2.0;
const SCALE_STEP = 0.05;
const DEFAULT_LOGO_SCALE = 1.0;

const MIN_MARGIN = -12;
const MAX_MARGIN = 24;
const MARGIN_STEP = 1;
const DEFAULT_MARGIN_PX = 8;

export const LOGO_CONSTANTS = {
  MIN_SCALE,
  MAX_SCALE,
  SCALE_STEP,
  DEFAULT_SCALE: DEFAULT_LOGO_SCALE,
  MIN_MARGIN,
  MAX_MARGIN,
  MARGIN_STEP,
  DEFAULT_MARGIN: DEFAULT_MARGIN_PX,
};
